module.exports = "/images/extra-flight.svg?31e7bc71795064ebf1af40066d82a0b4";